var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',[_vm._v("Applications That Need Pushed")]),_c('b-table',{attrs:{"items":_vm.applicants}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }